module.exports = __webpack_public_path__ + "static/img/imgPic.be34a8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/imgPic.jpg
// module id = wLXx
// module chunks = 0